import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import FormFieldWrapper from '@plone/volto/components/manage/Widgets/FormFieldWrapper';

import clearSVG from '@plone/volto/icons/clear.svg';

const messages = defineMessages({
  email: {
    id: 'Email',
    defaultMessage: 'Email',
  },
  clearEmail: {
    id: 'Clear email',
    defaultMessage: 'Clear email',
  },
});

const EmailWidgetComponent = (props) => {
  const { id, value, onChange, resettable, isDisabled, required } = props;

  const intl = useIntl();

  const onInputChange = (event) => {
    const raw = event.target.value;
    onChange(id, raw === '' ? undefined : raw);
  };

  const onReset = () => onChange(id, null);

  return (
    <FormFieldWrapper {...props} className="text">
      <div className="date-time-widget-wrapper email-widget-wrapper">
        <input
          type="email"
          id={`field-${id}`}
          name={id}
          disabled={isDisabled}
          required={required}
          value={value || ''}
          onChange={onInputChange}
        />
        {resettable && value && (
          <button
            type="button"
            disabled={isDisabled}
            onClick={onReset}
            className="item ui noborder button"
            aria-label={intl.formatMessage(messages.clearEmail)}
          >
            <Icon name={clearSVG} size="24px" className="close" />
          </button>
        )}
      </div>
    </FormFieldWrapper>
  );
};

EmailWidgetComponent.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  wrapped: PropTypes.bool,
  resettable: PropTypes.bool,
};

EmailWidgetComponent.defaultProps = {
  description: null,
  required: false,
  error: [],
  value: null,
  resettable: true,
};

export default EmailWidgetComponent;
